class EsaedroResourceAttachment {
   
    public Resource_ID: number = 0;
    public Item_ID: number = 0;
    public Id: number = 0;
    public Description: string = "";
    public AttachmentType: string = "image";
    public Content: any

    constructor(resource_ID:number, item_ID:number, id: number, content: any, description?: string, attachmentType?: string) {
        this.Resource_ID=resource_ID
        this.Item_ID=item_ID
        this.Id=id
        this.Description=description?description:this.Resource_ID.toString()
        this.AttachmentType=attachmentType?attachmentType:"image"
        this.Content = content
    }
}

export default EsaedroResourceAttachment;